import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'FieldValidationErrors'
})
export default class FieldValidationErrors extends Vue {
    @Prop({ required: true })
    errorList!: string[];
}